import React, { useEffect, useState } from "react";
import { ColumnValueRendererProps } from "../table.data.interface";
import { getItemNames } from "../../../services/monday-service";

const ConnectBoardsColumn = ({ columnData, otherBoardsValues }: ColumnValueRendererProps) => {
  const [itemNames, setItemNames] = useState();

  useEffect(() => {
    const fetchItemName = async (columnValue: string) => {
      const response = await getItemNames((columnValue as string).split(", "));

      setItemNames(response.map((item: any) => item.name).join(", "));
    };

    if (columnData.value !== "Empty Column" && columnData?.value) {
      fetchItemName(columnData?.value as string);
    } else if (otherBoardsValues && columnData?.linked_item_ids?.length) {
      fetchItemName((columnData?.linked_item_ids as string[])?.join(", ") ?? "");
    }
  }, [columnData.value, columnData?.linked_item_ids, otherBoardsValues]);

  if (
    columnData.value === "Empty Column" ||
    (!columnData?.linked_item_ids?.length && otherBoardsValues)
  ) {
    return null;
  }

  return <div>{itemNames}</div>;
};

export default ConnectBoardsColumn;
